import { useDroppable } from "@dnd-kit/core";
import { Box, Grid } from "@mui/material";
import AssetCard from "./AssetCard";

const DroppableSeriesCard = ({ asset }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: asset.id,
    data: { asset },
  });

  return (
    <Grid size={{ md: 4, xs: 12 }} ref={setNodeRef}>
      <Box
        sx={{
          borderRadius: 2,
          border: isOver ? "2px dashed" : "2px solid transparent",
          borderColor: isOver ? "primary.main" : "transparent",
          backgroundColor: isOver ? "action.hover" : "transparent",
          transition: "all 0.2s ease",
        }}
      >
        <AssetCard asset={asset} isWrapped />
      </Box>
    </Grid>
  );
};

export default DroppableSeriesCard;
